var _path, _circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2458 16.8983H21.4315V15.9094C21.4315 15.5949 21.4811 15.4686 21.5283 15.4125C21.5591 15.3758 21.6695 15.2754 22.0886 15.2754H23.3152H23.8152V14.7754V12.6926V12.2443L23.3696 12.1955C22.7599 12.1288 22.1468 12.0968 21.5334 12.0999C21.0587 12.0689 20.5828 12.1407 20.1382 12.3105C19.6874 12.4826 19.2797 12.7513 18.9437 13.0977C18.6077 13.444 18.3516 13.8597 18.1933 14.3156C18.0378 14.7631 17.9804 15.2386 18.0246 15.7101V16.9214H16.5189H16.0189V17.4214V19.7357V20.2357H16.5189H18.0246V25.2143H11.1343C11.0886 25.2143 11.0432 25.2053 11.0009 25.1877C10.9587 25.1702 10.9202 25.1445 10.8879 25.1122C10.8555 25.0798 10.8298 25.0414 10.8123 24.9991C10.7948 24.9568 10.7858 24.9115 10.7858 24.8657V11.1343C10.7858 11.0418 10.8225 10.9532 10.8879 10.8878C10.9532 10.8224 11.0419 10.7857 11.1343 10.7857H24.8658C24.9115 10.7857 24.9569 10.7947 24.9992 10.8122C25.0415 10.8298 25.0799 10.8554 25.1122 10.8878C25.1446 10.9202 25.1703 10.9586 25.1878 11.0009C25.2053 11.0432 25.2143 11.0885 25.2143 11.1343V24.8657C25.2143 24.9115 25.2053 24.9568 25.1878 24.9991C25.1703 25.0414 25.1446 25.0798 25.1122 25.1122C25.0799 25.1445 25.0415 25.1702 24.9992 25.1877C24.9569 25.2053 24.9115 25.2143 24.8658 25.2143H21.4315V20.2126H22.9449H23.3841L23.4407 19.777L23.7416 17.4627L23.815 16.8983H23.2458Z",
    fill: "#F0F0F0",
    stroke: "#F0F0F0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17,
    stroke: "#F0F0F0",
    strokeWidth: 2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.cc9f13451c633de083af95a28b38b501.svg";
export { ForwardRef as ReactComponent };